import { ParamMap } from '@angular/router';
import { AmplifyRouteTypeEnum } from '../enums/amplify-route-type.enum';

export class AmplifyRouteModel {
    type: AmplifyRouteTypeEnum;
    value?: string;
    queryParamMap?: ParamMap;

    constructor(type: AmplifyRouteTypeEnum, value?: string, queryParamMap?: ParamMap) {
        this.type = type;
        this.value = value;
        this.queryParamMap = queryParamMap;
    }
}
